export default __webpack_public_path__ + "static/media/portfolio-6.609861ab.jpg";